import type { ComponentType } from "react";
import { cn } from "@/lib/utils";

type Color = "gray" | "orange" | "sky";
type Size = "sm" | "md";

const colorClasses: Record<Color, string> = {
  gray: "bg-gray-300 text-gray-900",
  orange: "bg-orange-500/20 text-orange-500",
  sky: "bg-sky-500/10 text-sky-500",
};

const sizeClasses: Record<Size, { wrapper: string; icon: string }> = {
  md: { icon: "size-5", wrapper: "size-7" },
  sm: { icon: "size-4", wrapper: "size-6" },
};

interface IconBadgeProps
  extends Omit<React.ComponentProps<"div">, "children" | "color"> {
  color: Color;
  icon: ComponentType<{ className?: string }>;
  size?: Size;
}

export function IconBadge({
  color,
  icon: Icon,
  size = "md",
  className,
  ...props
}: IconBadgeProps) {
  const sizing = sizeClasses[size];
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full will-change-transform",
        sizing.wrapper,
        colorClasses[color],
        className
      )}
      {...props}
    >
      <Icon className={sizing.icon} />
    </div>
  );
}
